<template>
  <div id="containt" style="padding-left: 10px;">

    <div class="grid-height" style=" height: calc(100vh - -168px);">
      <vxe-grid align="center" :span-method="mergeRowMethod" show-overflow :stripe="true" :border="true" height="100%"
        :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
        @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

        <template #form>
          <div class="clearfix screen-btns" style="margin-top: 3px;">
            <div class="fl">
              <vxe-button v-if="recallDetailReportExport" status="primary" class="button-sty" icon="el-icon-plus" @click="doExcle">导出</vxe-button>
            </div>
            <div class="fr">
              <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
            </div>
          </div>
          <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
          @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">

            <vxe-form-item title="服务类型:">
              <template v-slot >
                <el-cascader v-model="formData.serviceTypeNames" :key="formData.value" :options="serviceTypeOption"  style="width:9vw;"
                             :props="props"
                             clearable

                ></el-cascader>
              </template>
            </vxe-form-item>

            <vxe-form-item title="工单号:" field="name">
              <template v-slot>
                <el-input  type="textarea" :autosize="{ minRows: 1, maxRows: 3, maxHeight: '100px' }" v-model="formData.orderNoArr"  style="width:9vw ;" clearable/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="用户电话:" field="name">
              <template v-slot>
                <el-input v-model="formData.userMobile" size="small" style="width:9vw ;" clearable/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="产品条码:" field="name">
              <template v-slot>
                <el-input v-model="formData.barcode" size="small" style="width:9vw ;" clearable/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="回访时间:" field="name" style="width:25%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 17vw;" v-model="formData.recallDate" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
                </el-date-picker>
              </template>
            </vxe-form-item>

            <vxe-form-item :title="$t('common.WorkOrderStatus')+':'" field="name">
              <template v-slot>
                <el-select v-model="formData.statList" clearable multiple
                           style="width:9vw ;">
                  <el-option :value="1" :label="$t('common.SignIn')"></el-option>
                  <el-option :value="2" :label="$t('common.publish')"></el-option>
                  <el-option :value="5" :label="$t('common.DispatchedNetwork')"></el-option>
                  <el-option :value="6" :label="$t('common.TheNetworkReceivedOrders')"></el-option>
                  <el-option :value="9" :label="$t('common.DispatchedMaster')"></el-option>
                  <el-option :value="10" :label="$t('common.MasterHasAcceptedOrder')"></el-option>
                  <el-option :value="11" :label="$t('common.HaveAlreadyReserved')"></el-option>
                  <el-option :value="13" :label="$t('common.HaveSetOut')"></el-option>
                  <el-option :value="17" :label="$t('common.HaveBeenDoor')"></el-option>
                  <el-option :value="20" :label="$t('common.CompletedTemporaryHold')"></el-option>
                  <el-option :value="61" :label="$t('common.completed')"></el-option>
                  <el-option :value="62" :label="$t('common.NetworkConfirmationCompletion')"></el-option>
                  <el-option :value="63" :label="$t('common.CenterCompletionAudit')"></el-option>
                  <el-option :value="64" :label="$t('common.HeadquartersCompletionAudit')"></el-option>
                  <el-option :value="91" :label="$t('common.ToBeSettled')"></el-option>
                  <el-option :value="92" :label="$t('common.RejectionSettlement')"></el-option>
                  <el-option :value="93" :label="$t('common.SettlementSuspension')"></el-option>
                  <el-option :value="94" :label="$t('common.HaveAlreadySettled')"></el-option>
                  <el-option :value="97" :label="$t('common.ApplyForClosure')"></el-option>
                  <el-option :value="98" :label="$t('common.HangUp')"></el-option>
                  <el-option :value="99" :label="$t('common.cancel')"></el-option>
                  <el-option :value="100" :label="$t('common.finish')"></el-option>
                </el-select>
              </template>
            </vxe-form-item>
            <vxe-form-item title="工单标签:" field="name">
              <template v-slot>
                <el-select v-model="formData.dispatchStats" clearable @change="selectChange" @clear="clearData" style="width:9vw ;" multiple>
                  <el-option v-for="item in dispatchStatOptions" :key="item.label" :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>
              </template>
            </vxe-form-item>
            <vxe-form-item title="服务中心:">
              <template v-slot >
                <org-search :org-name.sync="formData.orgName"
                            :org-id-path.sync="formData.orgIdPath"
                            :org-id.sync="formData.orgId"
                            :show="!currentIsSite"
                            style="width:9vw ;"
                />
              </template>
            </vxe-form-item>

            <vxe-form-item :title="$t('common.ServiceProvider')+':'" field="name">
              <template v-slot>
                <site-search :site-id.sync="formData.siteId" :show="!isSite" style="width:9vw ;" />
              </template>
            </vxe-form-item>

<!--            <vxe-form-item title="完工时间:" field="name">
              <template v-slot>
                <el-date-picker style="width: 17vw;" v-model="formData.completeDate" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
                </el-date-picker>
              </template>
            </vxe-form-item>-->
            <vxe-form-item title="回访完成时间:" field="name" style="width:25%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 17vw;" v-model="formData.recallFinishDate" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
                </el-date-picker>
              </template>
            </vxe-form-item>

            <vxe-form-item :title="$t('common.WarrantyType')+':'" field="name">
              <template v-slot>
                <el-select v-model="formData.guaranteeTypes" style="width:9vw ;" clearable multiple>
                  <el-option :value="1" label="保内"></el-option>
                  <el-option :value="2" label="保外"></el-option>
                  <el-option :value="3" label="未知"></el-option>
                </el-select>
              </template>
            </vxe-form-item>

            <vxe-form-item title="购买渠道:" field="name">
              <template v-slot>
                <el-select v-model="formData.buyChannelIds" placeholder="购买渠道" style="width:9vw ;" clearable multiple>
                  <el-option v-for="item in buyChannelOption" :key="item.buyChannelName"
                             :label="item.buyChannelName" :value="item.id" />
                </el-select>
              </template>
            </vxe-form-item>

            <vxe-form-item title="产品大类:" field="name">
              <template v-slot>
                <el-select v-model="formData.bigCategoryIds" placeholder="产品大类" style="width:9vw;" clearable multiple>
                  <el-option v-for="item in bigCategoryOption" :key="item.categoryName"
                             :label="item.categoryName" :value="item.id" />
                </el-select>
              </template>
            </vxe-form-item>

<!--            <vxe-form-item title="购买时间:" field="name">
              <template v-slot>
                <el-date-picker style="width: 17vw;" v-model="formData.buyDate" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
                </el-date-picker>
              </template>
            </vxe-form-item>-->

            <vxe-form-item title="用户满意度:" field="name">
              <template v-slot>
                <el-select v-model="formData.manYis" style="width:9vw ;" clearable multiple>
                  <el-option :value="null" label="全部"></el-option>
                  <el-option :value="1" label="非常满意"></el-option>
                  <el-option :value="2" label="满意"></el-option>
                  <el-option :value="3" label="一般"></el-option>
                  <el-option :value="4" label="不满意"></el-option>
                  <el-option :value="5" label="非常不满意"></el-option>
                  <el-option :value="6" label="未评价"></el-option>
                </el-select>
              </template>
            </vxe-form-item>

            <vxe-form-item title="不满意原因:" field="name">
              <template v-slot>
                <el-select v-model="formData.unSatisfiedReasonIds"
                           style="width:17vw;" placeholder="请选择" clearable multiple
                >
                  <el-option v-for="item in unSatisfiedOption"
                             :key="item.id"
                             :label="item.label"
                             :value="item.id"
                  ></el-option>
                </el-select>
              </template>
            </vxe-form-item>

            <vxe-form-item title="回访结果:" field="name">
              <template v-slot>
                <el-select v-model="formData.huiFangQingKuangs" style="width:9vw ;" clearable multiple>
                  <el-option :value="null" label="全部"></el-option>
                  <el-option :value="1" label="属实"></el-option>
                  <el-option :value="2" label="不属实"></el-option>
                  <el-option :value="3" label="无果"></el-option>
                </el-select>
              </template>
            </vxe-form-item>

            <vxe-form-item title="回访次数:" field="name">
              <template v-slot>
                <el-input v-model="formData.recallBegin" class="priceInput" style="width: 4vw" clearable/><span
                style="display: inline-block;width:1vw;text-align: center;">-</span><el-input
                v-model="formData.recallEnd" class="priceInput" ref="prodEnd" style="width:4vw;" clearable/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="创建人:" field="name">
              <template v-slot>
                <username-search :username.sync="formData.createBy" style="width:9vw ;"/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="回访人:" field="name">
              <template v-slot>
                <username-search :username.sync="formData.recallMan" style="width:9vw ;"/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="配件数量:" field="name">
              <template v-slot>
                <el-input v-model="formData.partsBegin" class="priceInput" style="width:8vw;" clearable/><span
                style="display: inline-block;width:1vw;text-align: center;">-</span><el-input
                v-model="formData.partsEnd" class="priceInput" ref="prodEnd" style="width: 8vw;" clearable/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="配件情况:" field="name">
              <template v-slot>
                <el-select v-model="formData.partsRecalls" style="width:9vw ;" clearable multiple>
                  <el-option :value="null" label="全部"></el-option>
                  <el-option :value="1" label="属实"></el-option>
                  <el-option :value="2" label="不属实"></el-option>
                  <el-option :value="3" label="无果"></el-option>
                  <el-option :value="0" label="空"></el-option>
                </el-select>
              </template>
            </vxe-form-item>

            <vxe-form-item title="回访方式:" field="name">
              <template v-slot>
                <el-select v-model="formData.recallTypes" style="width:9vw ;" clearable multiple>
                  <el-option :value="null" label="全部"></el-option>
                  <el-option :value="1" label="人工回访"></el-option>
                  <el-option :value="2" label="机器人回访"></el-option>
                  <el-option :value="3" label="微信点评"></el-option>
                  <el-option :value="4" label="短信评价"></el-option>
                  <el-option :value="5" label="批量导入"></el-option>
                  <el-option :value="6" label="京东虚拟号"></el-option>
                </el-select>
              </template>
            </vxe-form-item>

            <vxe-form-item title="工单来源:" field="name">
              <template v-slot>
                <el-select v-model="formData.orderTypeIds" style="width:9vw ;" clearable multiple>
                  <el-option v-for="item in orderTypeOptions"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"
                  >
                  </el-option>
                </el-select>
              </template>
            </vxe-form-item>
          </vxe-form>
        </template>
        <!-- 分页器 -->
        <template #pager>
          <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
        </template>

        <template #guaranteeTypeSlots="{ row }">
          <span v-if="row.guaranteeType == 1" class="txt-status disable">保内</span>
          <span v-else-if="row.guaranteeType == 2" class="txt-status neutral">保外</span>
          <span v-else-if="row.guaranteeType == 3" class="txt-status neutral">未知</span>
        </template>

        <template #partsQtySlots="{ row }">
          <span v-if="row.partsQty > 0" class="txt-status neutral">是</span>
          <span v-else class="txt-status disable">否</span>
        </template>

        <template #showStat="{ row }">
          <span class="txt-status " v-if="row.stat == 1">登记</span>
          <span class="txt-status " v-else-if="row.stat == 2">发布</span>
          <span class="txt-status " v-else-if="row.stat == 5">已派网点</span>
          <span class="txt-status " v-else-if="row.stat == 6">网点已接单</span>
          <span class="txt-status " v-else-if="row.stat == 9">已派师傅</span>
          <span class="txt-status " v-else-if="row.stat == 10">师傅已接单</span>
          <span class="txt-status " v-else-if="row.stat == 11">已预约</span>
          <span class="txt-status " v-else-if="row.stat == 13">已出发</span>
          <span class="txt-status " v-else-if="row.stat == 17">已上门</span>
          <span class="txt-status neutral" v-else-if="row.stat == 20">完工暂存</span>
          <span class="txt-status " v-else-if="row.stat == 61">已完工</span>
          <span class="txt-status " v-else-if="row.stat == 62">网点确认完工</span>
          <span class="txt-status neutral" v-else-if="row.stat == 63">中心完工审核</span>
          <span class="txt-status neutral" v-else-if="row.stat == 64">总部完工审核</span>
          <span class="txt-status neutral" v-else-if="row.stat == 91">待结算</span>
          <span class="txt-status disable" v-else-if="row.stat == 92">结算驳回</span>
          <span class="txt-status disable" v-else-if="row.stat == 93">结算中止</span>
          <span class="txt-status " v-else-if="row.stat == 94">已结算</span>
          <span class="txt-status disable" v-else-if="row.stat == 97">申请关闭</span>
          <span class="txt-status disable" v-else-if="row.stat == 98">挂起</span>
          <span class="txt-status disable" v-else-if="row.stat == 99">取消</span>
          <span class="txt-status disable" v-else-if="row.stat == 100">结束</span>
        </template>

        <template #areaSlots="{ row }">
          <span>{{ row.userProvice }}{{ row.userCity }}{{ row.userCounty }}{{ row.userTown }}{{ row.userAddress }}</span>
        </template>
      </vxe-grid>
    </div>

  </div>
</template>

<script>
import { initVxeTable } from '@/const/crud/admin/table'
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import OrgSearch from "@/components/formItem/orgSearch.vue";
import SiteSearch from "@/components/formItem/siteSearch.vue";
import UsernameSearch from "@/components/formItem/usernameSearch.vue";
import {siteMixins} from "@/mixins/tabChang";
import store from "@/store";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import {mapGetters} from "vuex";

export default {
  mixins: [siteMixins,selectDialogMixins],
  name: 'recallDetailReport',

  components: { pager,OrgSearch ,SiteSearch,UsernameSearch},
  data() {
    return {
      recallInfoReportExport: false,
      props: { multiple: true },
      getAreaDataUrl: '/basic/basArea/getList',
      orderTypeOptions: [],
      buyChannelOption: [],
      bigCategoryOption: [],
      serviceTypeOption: [],
      dispatchStatOptions: [],
      unSatisfiedOption: [],
      showEdit: false,
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      isSite: null,
      pageSizes: [10, 20, 100],
      requestParam: {
        buyChannelIds: [],
        siteId:null,
        statList:[],
        dispatchStats:[],
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 10,  // 页面数据量
        orgId: null,
        serviceTypeIds: '',
        bigCategoryIds: [],
        orderTypeIds: [],
        orderNoArr: '',
        userMobile: '',
        barcode: '',
        manYis: [],
        unSatisfiedReasonIds: [],
        huiFangQingKuangs: [],
        recallBegin: null,
        recallEnd: null,
        createBy: '',
        recallMan: '',//回访人
        partsBegin: null,
        partsEnd: null,
        guaranteeTypes: [],
        recallDateBegin: null,
        recallDateEnd: null,
        recallTypes: [],
        partsRecalls: [],
        recallFinishDate:null,
      },

      formData: {
        partsRecalls: [],
        recallTypes: [],
        orgId: null,
        siteId: null,
        dispatchStats:[],
        statList:[],
        recallDateBegin: null,
        recallDateEnd: null,
        recallDate: null,
        recallFinishDate:null,
        buyChannelIds: [],
        bigCategoryIds: [],
        serviceTypeNames: [],
        orderTypeIds: [],
        orderNoArr: '',
        userMobile: '',
        barcode: '',
        manYis: [],
        unSatisfiedReasonIds: [],
        huiFangQingKuangs: [],
        recallBegin: null,
        recallEnd: null,
        createBy: '',
        recallMan: '',//回访人
        partsBegin: null,
        partsEnd: null,
        guaranteeTypes: [],
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      searchBarcode: '',
      searchItemCode: '',
      searchItemName: '',
      total: 0,  // 数据总数
      vxeOption: {},
      columns: [
        {title: '工单编号', field: 'orderNo', width: 180, },
        {title: '电话号码', field: 'userMobile', width: 150,},
        {title: '客户名称', field: 'userName', width: 150,},
        {title: '地址', field: 'userAddress', width: 250,slots: {default: 'areaSlots'}},
        {title: '服务类型', field: 'serviceTypeName', width: 125},
        {title: '产品大类', field: 'bigCategoryName', width: 235,},
        {title: '条码', field: 'inCode', width: 150,},
        {title: '创建日期', field: 'createTime', width: 150,},
        {title: '工单状态', field: 'stat', width: 235,slots: {default: 'showStat'}},
        {title: '工单标签', field: 'dispatchStat', width: 150,},
        {title: '完工日期', field: 'completeTime', width: 150,},
        {title: '是否更换配件', field: 'partsQty', width: 150,slots: {default: 'partsQtySlots'}},
        {title: '配件更换数量', field: 'partsQty', width: 125,},
        {title: '用户满意度', field: 'manYi', width: 150,},
        {title: '不满意原因名称', field: 'unSatisfiedReasonName', width: 150,},
        {title: '无果原因', field: 'noResultReasonName', width: 150,},
        {title: '回访完成时间', field: 'recallCompleteDate', width: 150,},
        {title: '回访结果', field: 'huiFangQingKuang', width: 150,},
        {title: '不属实原因名称', field: 'notTrueReasonName', width: 150,},
        {title: '不满意原因描述', field: 'unSatisfiedRemark', width: 150,},
        {title: '配件回访结果', field: 'partsRecallResult', width: 150,},
        {title: '回访次数', field: 'recallNumber', width: 150,},
        {title: '回访人', field: 'recallMan', width: 150,},
        {title: '回访时间', field: 'recallDate', width: 150,},
        {title: '保修类型', field: 'guaranteeType', width: 150,slots: {default: 'guaranteeTypeSlots'}},
        {title: '故障现象', field: 'symptomName', width: 150,},
        {title: '故障原因', field: 'reasonName', width: 150,},
        {title: '维修措施', field: 'methodName', width: 150,},
        {title: '创建人', field: 'createBy', width: 150,},
        {title: '工单来源', field: 'orderTypeName', width: 125,},
        {title: '购买渠道', field: 'buyChannelName', width: 100,},
        {title: '购买日期', field: 'buyDate', width: 100,},
        {title: '服务商编号', field: 'userAccount', width: 100,},
        {title: '服务商', field: 'siteName', width: 150,},
        {title: '取消原因', field: 'returnName', width: 150,},
        {title: '服务需求', field: 'appeals', width: 150,},
      ],
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },

    'formData.recallDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.recallDateBegin = newVal[0]
          this.formData.recallDateEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.recallDateBegin = null
          this.formData.recallDateEnd = null
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["permissions"]),
  },

  created() {
    this.recallDetailReportExport = this.permissions['recallDetailReportExport']
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId) {
      this.isSite = true;
    }
  },

  mounted() {
    this.initSetting();
    this.initSearchDate()
    this.loadDispatchStatOptions()
    this.loadServiceTypeOptions()
    this.loadBuyChannelOptions()
    this.loadbigCategoryOptions()
    this.loadOrderTypeOption()
    this.loadUnSatisfiedOption()//加载不满意原因
  },

  methods: {
		toFilterData() {
            this.searchEvent();
     },
    //导出
    doExcle(){
      this.$mask.open()
      doCheckExcle(fileNames.recallDetailReport).then(response => {
        if (response.data.msg=="success"){
          doDownLoadExcle(api.recallDetailReport.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          }).catch(() => {
            this.$mask.close()
          })
        }else{
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

    loadUnSatisfiedOption() {
      this.$http.get('/admin/dict/type/' + "不满意原因").then(res => {
        this.unSatisfiedOption = res.data.data
      })
    },

    // 加载工单来源
    loadOrderTypeOption() {
      this.$http.post(api.basOrderType.getListUrl, {}).then(res => {
        this.orderTypeOptions = []
        res.data.data.forEach(item => {
          this.orderTypeOptions.push({
            value: item.id,
            label: item.orderTypeName
          })
        })
      })
    },

    //加载产品大类
    loadbigCategoryOptions() {
      this.$http({
        url: api.basItemCategory.getBigItemCategory,
        method: 'get',
        params: {
          companyId : store.getters.userInfo.tenantId
        }
      }).then(res => {
        this.bigCategoryOption = res.data.data
        console.log("bigCategoryOption",this.bigCategoryOption)
      })
    },

    loadServiceTypeOptions() {
      this.$http.post(api.basServiceType.getOptionUrl, {}).then(res => {
        // console.log(res.data.data, 'option')
        let list = []
        res.data.data.forEach(item => {
          if (item.children.length == 0) {
            delete item.children
          }
          list.push(item)
        })
        this.serviceTypeOption = list
        console.log(this.serviceTypeOption,"服务类实现");
      })
    },

    //加载购买渠道
    loadBuyChannelOptions() {
      this.$http({
        url: api.basBuyChannel.getListDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.buyChannelOption = res.data.data
        console.log("buyChannelOption",this.buyChannelOption)
      })
    },

    loadDispatchStatOptions() {
      this.$http({
        url: api.basDispatchStat.getList,
        method: 'post',
        data: {
          isShow: 1  //工单查询栏目是否显示:0否1是
        }
      }).then(res => {
        this.dispatchStatOptions = []
        res.data.data.forEach(item => {
          this.dispatchStatOptions.push({label: item.dispatchStat})
        })
      })
    },

    selectChange() {
      this.$emit('update:dispatchStat', this.dispatchStats)
    },

    clearData() {
      this.$emit('update:dispatchStat', null)
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      this.formData.recallDate = [start, end]
      this.requestParam.recallDateBegin = start
      this.requestParam.recallDateEnd = end
    },

    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      const fields = ['barcode', 'supplierName', 'produceCompany', "itemName", 'Production']
      const cellValue = row[column.property]
      if (cellValue && fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.recallDetailReport.getPage,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)

      var typeIds = "";
      if(this.formData.serviceTypeNames != null){
        this.formData.serviceTypeNames.forEach(item => {
          typeIds += item + ","
        })
      }
      if(typeIds != null && typeIds != ""){
        typeIds = typeIds.slice(0,typeIds.length-1);
      }
      this.requestParam.serviceTypeIds = typeIds;

      if(!this.formData.recallDateBegin){
        this.$message.warning('必须选择回访操作时间');
        return
      }
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      console.log(id)
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  }
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
